export const time = [
  "12:00 AM",
  "12:30 AM",
  "01:00 AM",
  "01:30 AM",
  "02:00 AM",
  "02:30 AM",
  "03:00 AM",
  "03:30 AM",
  "04:00 AM",
  "04:30 AM",
  "05:00 AM",
  "05:30 AM",
  "06:00 AM",
  "06:30 AM",
  "07:00 AM",
  "07:30 AM",
  "08:00 AM",
  "08:30 AM",
  "09:00 AM",
  "09:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "01:00 PM",
  "01:30 PM",
  "02:00 PM",
  "02:30 PM",
  "03:00 PM",
  "03:30 PM",
  "04:00 PM",
  "04:30 PM",
  "05:00 PM",
  "05:30 PM",
  "06:00 PM",
  "06:30 PM",
  "07:00 PM",
  "07:30 PM",
  "08:00 PM",
  "08:30 PM",
  "09:00 PM",
  "09:30 PM",
  "10:00 PM",
  "10:30 PM",
  "11:00 PM",
  "11:30 PM",
];

export const timeOptions = time.map((t) => {
  return { label: t, value: t };
});

export const timezones = [
  { value: "GMT-12:00", label: "GMT-12:00" },
  { value: "GMT-11:00", label: "GMT-11:00 - Midway" },
  { value: "GMT-10:00", label: "GMT-10:00 - Honolulu" },
  { value: "GMT-09:00", label: "GMT-09:00 - Anchorage" },
  { value: "GMT-08:00", label: "GMT-08:00 - Los Angeles" },
  { value: "GMT-07:00", label: "GMT-07:00 - Denver" },
  { value: "GMT-06:00", label: "GMT-06:00 - Chicago" },
  { value: "GMT-05:00", label: "GMT-05:00 - New York" },
  { value: "GMT-04:00", label: "GMT-04:00 - Caracas" },
  { value: "GMT-04:00", label: "GMT-04:00 - Halifax" },
  { value: "GMT-03:30", label: "GMT-03:30 - St. John's" },
  { value: "GMT-03:00", label: "GMT-03:00 - Buenos Aires" },
  { value: "GMT-02:00", label: "GMT-02:00 - South Georgia" },
  { value: "GMT-01:00", label: "GMT-01:00 - Azores" },
  { value: "GMT+00:00", label: "GMT+00:00 - UTC" },
  { value: "GMT+00:00", label: "GMT+00:00 - London" },
  { value: "GMT+01:00", label: "GMT+01:00 - Berlin" },
  { value: "GMT+02:00", label: "GMT+02:00 - Athens" },
  { value: "GMT+03:00", label: "GMT+03:00 - Moscow" },
  { value: "GMT+03:30", label: "GMT+03:30 - Tehran" },
  { value: "GMT+04:00", label: "GMT+04:00 - Dubai" },
  { value: "GMT+04:30", label: "GMT+04:30 - Kabul" },
  { value: "GMT+05:00", label: "GMT+05:00 - Karachi" },
  { value: "GMT+05:30", label: "GMT+05:30 - Kolkata" },
  { value: "GMT+05:45", label: "GMT+05:45 - Kathmandu" },
  { value: "GMT+06:00", label: "GMT+06:00 - Dhaka" },
  { value: "GMT+06:30", label: "GMT+06:30 - Yangon" },
  { value: "GMT+07:00", label: "GMT+07:00 - Bangkok" },
  { value: "GMT+08:00", label: "GMT+08:00 - Shanghai" },
  { value: "GMT+09:00", label: "GMT+09:00 - Tokyo" },
  { value: "GMT+09:30", label: "GMT+09:30 - Adelaide" },
  { value: "GMT+10:00", label: "GMT+10:00 - Sydney" },
  { value: "GMT+11:00", label: "GMT+11:00 - Nouméa" },
  { value: "GMT+12:00", label: "GMT+12:00 - Auckland" },
  { value: "GMT+12:45", label: "GMT+12:45 - Chatham Islands" },
  { value: "GMT+13:00", label: "GMT+13:00 - Tonga" },
  { value: "GMT+14:00", label: "GMT+14:00 - Kiritimati" },
];

export const currencies = [
  { code: "USD", symbol: "$" }, // United States Dollar
  { code: "EUR", symbol: "€" }, // Euro
  { code: "GBP", symbol: "£" }, // British Pound Sterling
  { code: "JPY", symbol: "¥" }, // Japanese Yen
  { code: "CNY", symbol: "¥" }, // Chinese Yuan
  { code: "INR", symbol: "₹" }, // Indian Rupee
  { code: "AUD", symbol: "A$" }, // Australian Dollar
  { code: "CAD", symbol: "C$" }, // Canadian Dollar
  { code: "CHF", symbol: "CHF" }, // Swiss Franc
  { code: "NZD", symbol: "NZ$" }, // New Zealand Dollar
  { code: "SEK", symbol: "kr" }, // Swedish Krona
  { code: "NOK", symbol: "kr" }, // Norwegian Krone
  { code: "DKK", symbol: "kr" }, // Danish Krone
  { code: "ZAR", symbol: "R" }, // South African Rand
  { code: "RUB", symbol: "₽" }, // Russian Ruble
  { code: "BRL", symbol: "R$" }, // Brazilian Real
  { code: "MXN", symbol: "$" }, // Mexican Peso
  { code: "SGD", symbol: "S$" }, // Singapore Dollar
  { code: "HKD", symbol: "HK$" }, // Hong Kong Dollar
  { code: "KRW", symbol: "₩" }, // South Korean Won
  { code: "TRY", symbol: "₺" }, // Turkish Lira
  { code: "IDR", symbol: "Rp" }, // Indonesian Rupiah
  { code: "THB", symbol: "฿" }, // Thai Baht
  { code: "MYR", symbol: "RM" }, // Malaysian Ringgit
  { code: "NGN", symbol: "₦" }, // Nigerian Naira
  { code: "EGP", symbol: "£" }, // Egyptian Pound
  { code: "PLN", symbol: "zł" }, // Polish Zloty
  { code: "CZK", symbol: "Kč" }, // Czech Koruna
  { code: "HUF", symbol: "Ft" }, // Hungarian Forint
];
